import React, { useEffect } from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import ImpersonationBanner from '../admin/ImpersonationBanner';
import { useAuth } from '../../context/AuthContext';
import { isImpersonating } from '../../lib/auth/impersonationService';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, userRole } = useAuth();
  
  // Derive isAdmin from cached userRole in AuthContext
  const isAdmin = userRole === 'admin';
  
  // Check if currently impersonating
  const showImpersonationBanner = isImpersonating();
  
  // OPTIMIZATION: Removed redundant user_roles database check
  // The userRole from AuthContext already indicates if user has completed registration
  // userRole will be 'guest' for users without roles, 'user' or 'admin' for registered users
  
  // Add event listeners to prevent copy events for non-admin users
  useEffect(() => {
    // Skip adding copy prevention for admin users
    if (isAdmin) {
      return;
    }
    
    const preventCopy = (e: Event) => {
      e.preventDefault();
      return false;
    };
    
    // Add event listeners only for non-admin users
    document.addEventListener('copy', preventCopy);
    document.addEventListener('cut', preventCopy);
    document.addEventListener('contextmenu', preventCopy);
    
    // Clean up event listeners on unmount
    return () => {
      document.removeEventListener('copy', preventCopy);
      document.removeEventListener('cut', preventCopy);
      document.removeEventListener('contextmenu', preventCopy);
    };
  }, [isAdmin]);
  
  return (
    <div className={`flex flex-col min-h-screen ${!isAdmin ? 'no-select' : ''}`}>
      {showImpersonationBanner && <ImpersonationBanner />}
      <Navbar />
      <main className={`flex-grow ${showImpersonationBanner ? 'pt-16' : ''}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
